import {createMuiTheme} from '@material-ui/core/styles'
        
export const theme = createMuiTheme({  // #1
  palette: {
    primary: {
      light: '#536bcd',
      main: '#0e419b',
      dark: '#001c6c',
      contrastText: '#000000',
    },
    secondary: {
      light: '#57975b',
      main: '#2e7d32',
      dark: '#205723',
      contrastText: '#ffffff',
    },
  },
})